import fetch from 'cross-fetch'; // eslint-disable-line no-unused-vars
import { omit } from 'lodash';
import { createAction } from 'redux-api-middleware';
import Routes from '../utils/routes.js.erb';
import { API_FAILURE, authHeaders } from './index';
import { addMeta, tranformSuccessPayload, transformBodyParams } from './transformers';
import { SHOW_MODAL } from './internal';

export const ENQUEUE_ASQ_CSV_EXPORT_REQUEST = 'ENQUEUE_ASQ_CSV_EXPORT_REQUEST ';
export const ENQUEUE_ASQ_CSV_EXPORT_RECEIVE = 'ENQUEUE_ASQ_CSV_EXPORT_RECEIVE ';

const postEnqueueAsqCSVReport = (params, meta) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_asq_surveys_path(),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      body: transformBodyParams(params),
      types: [
        addMeta(ENQUEUE_ASQ_CSV_EXPORT_REQUEST, meta),
        tranformSuccessPayload(ENQUEUE_ASQ_CSV_EXPORT_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_ASQ_CSV_EXPORT_RECEIVE) {
      clearTimeout(scheduleAsqSurveysCSVReportRefreshId);
      dispatch(fetchAsqSurveysCSVReport());
    }

    return actionResponse;
  };
};

export const enqueueAsqCSVReport = (params = {}, meta = {}) => (dispatch, getState) => {
  const state = getState();
  const query = omit({ ...state.meta.surveys, ...params }, ['q', 'page', 'totalPages']);

  return dispatch(postEnqueueAsqCSVReport(query, meta));
};


export const ASQ_SURVEYS_CSV_REPORT_REQUEST = 'ASQ_SURVEYS_CSV_REPORT_REQUEST';
export const ASQ_SURVEYS_CSV_REPORT_RECEIVE = 'ASQ_SURVEYS_CSV_REPORT_RECEIVE';

const PENDING_ASQ_SURVEYS_CSV_REPORT_STATUSES = ['pending', 'in_progress'];

const fetchAsqSurveysCSVReport = () => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.csv_export_api_dashboard_asq_surveys_path(),
      headers: authHeaders(),
      method: 'GET',
      types: [
        ASQ_SURVEYS_CSV_REPORT_REQUEST,
        tranformSuccessPayload(ASQ_SURVEYS_CSV_REPORT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleAsqSurveysCSVReportRefresh());
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === ASQ_SURVEYS_CSV_REPORT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_ASQ_SURVEYS_CSV_REPORT_STATUSES.includes(status)) {
        dispatch(scheduleAsqSurveysCSVReportRefresh());
      }
    }

    return actionResponse;
  };
}

export const loadAsqSurveysCSVReport = (interval = window.POLLING_INTERVAL) => {
  return scheduleAsqSurveysCSVReportRefresh(interval);
};

let scheduleAsqSurveysCSVReportRefreshId = null
const scheduleAsqSurveysCSVReportRefresh = (interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleAsqSurveysCSVReportRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchAsqSurveysCSVReport());
    }, interval);
  };
};

export const ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST = 'ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST';
export const ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE = 'ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE';

const PENDING_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_STATUSES = ['pending', 'in_progress'];

const fetchAsqSurveyResultsParentEmailSendout = (id) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.results_parent_email_sendout_api_dashboard_asq_survey_path(id),
      headers: authHeaders(),
      method: 'GET',
      types: [
        ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST,
        tranformSuccessPayload(ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === API_FAILURE && actionResponse.payload.status === 429) {
      dispatch(scheduleAsqSurveyResultsParentEmailSendoutRefresh(id));
      return actionResponse.payload.previous;
    }

    if (actionResponse && actionResponse.type === ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE) {
      const { status } = actionResponse.payload;

      if (PENDING_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_STATUSES.includes(status)) {
        dispatch(scheduleAsqSurveyResultsParentEmailSendoutRefresh(id));
      }
    }

    return actionResponse;
  };
};

export const loadAsqSurveyResultsParentEmailSendout = (id, interval = window.POLLING_INTERVAL) => {
  return scheduleAsqSurveyResultsParentEmailSendoutRefresh(id, interval);
};

let scheduleAsqSurveyResultsParentEmailSendoutRefreshId = null
const scheduleAsqSurveyResultsParentEmailSendoutRefresh = (id, interval = window.POLLING_INTERVAL) => {
  return (dispatch) => {
    scheduleAsqSurveyResultsParentEmailSendoutRefreshId = window.TIMEOUTS.setTimeout(() => {
      dispatch(fetchAsqSurveyResultsParentEmailSendout(id, interval));
    }, interval);
  };
};

export const ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST = 'ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST';
export const ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE = 'ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE';

const postEnqueueAsqSurveyResultsParentEmailSendout = (id, meta) => {
  return async (dispatch, _getState) => {
    const actionResponse = await dispatch(createAction({
      endpoint: Routes.results_parent_email_sendout_api_dashboard_asq_survey_path(id),
      method: 'POST',
      headers: { ...authHeaders(), 'Content-Type': 'application/json' },
      types: [
        addMeta(ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_REQUEST, meta),
        tranformSuccessPayload(ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE, meta),
        API_FAILURE,
      ],
      fetch: fetch,
    }));

    if (actionResponse && actionResponse.type === ENQUEUE_ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE) {
      clearTimeout(scheduleAsqSurveyResultsParentEmailSendoutRefreshId);
      dispatch(fetchAsqSurveyResultsParentEmailSendout(id));
    }

    return actionResponse;
  };
};

export const enqueueAsqSurveyResultsParentEmailSendout = (id) => (dispatch) => {
  return dispatch(postEnqueueAsqSurveyResultsParentEmailSendout(id));
};

export const showAsqSurveyResultsParentEmailSendoutConfirmationModal = (props = {}) => ({
  type: SHOW_MODAL,
  modalType: 'ASQ_SURVEY_EMAIL_SENDOUT_CONFIRMATION',
  modalProps: props,
});
